"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var json_api_fetch_1 = require("./json_api_fetch");
/**
 * Fetch wishes for a a wall and response in Json API format
 * @param query [WishesFetchQuery] available options:
 *                    - wallId [number] id of the wall
 *                    - pageStart [string] (optional) the wishes api is paginated, specify this to get to certain pages
 *                                            or don't pass this to get the first page
 */
function fetchWishes(wishQuery) {
  // pageStart is string | undefined (since it's optional) but @padlet/fetch needs a string so we have to do this :(
  var query = {
    wall_id: wishQuery.wallId.toString()
  };
  if (wishQuery.pageStart) {
    query.page_start = wishQuery.pageStart;
  }
  return (0, json_api_fetch_1.jsonApiFetch)('wishes', {
    query: query
  });
}
exports.default = fetchWishes;